
import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";
import { getSchedulesApi, updateScheduleApi } from "../../helpers/api/schedules";
import { ScheduleActionTypes, scheduleApiResponseError, scheduleApiResponseSuccess, ScheduleData } from "./scheduleTypes";
import { ScheduleUpdatePayload } from "../../types/Schedule";



/**
 * Get schedules
 * @param {*} payload - 
 */
function* getSchedule(action : {type: string; payload : { data : {id: number}}}): SagaIterator {
  try {
    const schedule = yield call(getSchedulesApi,action.payload.data.id);
    yield put(scheduleApiResponseSuccess(ScheduleActionTypes.GET_SCHEDULES, schedule));
  } catch (error: any) {
     const errorMessage = error.response?.data?.message || 'Error desconocido';
    yield put(scheduleApiResponseError(ScheduleActionTypes.GET_SCHEDULES, errorMessage));
  }
}


/**
 * Update Schedule
 * @param {*} payload - 
 */
function* updateSchedule(action : {type : string , payload : ScheduleUpdatePayload}): SagaIterator {
  try {
    const schedule = yield call(updateScheduleApi, action.payload);
    yield put(scheduleApiResponseSuccess(ScheduleActionTypes.UPDATE_SCHEDULE, schedule));
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'Error desconocido';
    yield put(scheduleApiResponseError(ScheduleActionTypes.UPDATE_SCHEDULE, errorMessage));
  }
}

export function* watchUpdateSchedule() {
  yield takeEvery(ScheduleActionTypes.UPDATE_SCHEDULE, updateSchedule);
}



export function* watchGetSchedule() {
  yield takeEvery(ScheduleActionTypes.GET_SCHEDULES, getSchedule);
}

function* openModalSchedule(): SagaIterator{
    yield put(scheduleApiResponseSuccess(ScheduleActionTypes.OPEN_MODAL,""));
 
}

export function* watchOpenModalSchedule() {
  yield takeEvery(ScheduleActionTypes.OPEN_MODAL,openModalSchedule);
}

function* closeModalSchedule(): SagaIterator{
    yield put(scheduleApiResponseSuccess(ScheduleActionTypes.CLOSE_MODAL,""));
 
}

export function* watchCloseModalSchedule() {
  yield takeEvery(ScheduleActionTypes.CLOSE_MODAL,closeModalSchedule);
}


function* scheduleSaga() {
  yield all([
    fork(watchCloseModalSchedule),
    fork(watchOpenModalSchedule),
    fork(watchUpdateSchedule),
    fork(watchGetSchedule),
  ]);
}

export default scheduleSaga;
